import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { NamedLink } from '../../components';
import audi from '../../assets/brands/audi.svg';
import bmw from '../../assets/brands/bmw.svg';
import ford from '../../assets/brands/ford.svg';
import kia from '../../assets/brands/kia.svg';
import mercedes from '../../assets/brands/mercedes.svg';
import peugeot from '../../assets/brands/peugeot.svg';
import polestar from '../../assets/brands/polestar.svg';
import porsche from '../../assets/brands/porsche.svg';
import tesla from '../../assets/brands/tesla.svg';
import toyota from '../../assets/brands/toyota.svg';
import volkswagen from '../../assets/brands/volkswagen.svg';
import volvo from '../../assets/brands/volvo.svg';
import css from './BrandGrid.module.css';

const DEFAULT_BRANDS = [
  { id: 'audi', label: 'Audi', logo: audi },
  { id: 'bmw', label: 'BMW', logo: bmw },
  { id: 'ford', label: 'Ford', logo: ford },
  { id: 'kia', label: 'Kia', logo: kia },
  { id: 'mercedes-benz', label: 'Mercedes', logo: mercedes },
  { id: 'peugeot', label: 'Peugeot', logo: peugeot },
  { id: 'polestar', label: 'Polestar', logo: polestar },
  { id: 'porsche', label: 'Porsche', logo: porsche },
  { id: 'tesla', label: 'Tesla', logo: tesla },
  { id: 'toyota', label: 'Toyota', logo: toyota },
  { id: 'volkswagen', label: 'Volkswagen', logo: volkswagen },
  { id: 'volvo', label: 'Volvo', logo: volvo },
];

const BrandGrid = ({ brands = DEFAULT_BRANDS }) => (
  <section className={css.root}>
    <div className={css.grid}>
      {brands.map(brand => (
        <NamedLink
          key={brand.id}
          name="SearchPage"
          to={{ search: `?pub_categoryLevel1=${encodeURIComponent(brand.id)}` }}
          className={css.card}
          aria-label={brand.label}
        >
          <div className={css.logoWrap}>
            <img src={brand.logo} alt={brand.label} className={css.logo} loading="lazy" />
          </div>
          <span className={css.label}>{brand.label}</span>
        </NamedLink>
      ))}
    </div>
    <div className={css.viewAllWrap}>
      <NamedLink name="SearchPage" className={css.viewAll}>
        Alla märken
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </NamedLink>
    </div>
  </section>
);

BrandGrid.propTypes = {
  brands: arrayOf(shape({ id: string.isRequired, label: string.isRequired, logo: string.isRequired })),
};

export default BrandGrid;
